export default __webpack_public_path__ + "static/media/customs-processing-icon.98c8fe54.svg";